import { render, staticRenderFns } from "./restriction-modal.vue?vue&type=template&id=0fb58615"
import script from "./restriction-modal.vue?vue&type=script&lang=js"
export * from "./restriction-modal.vue?vue&type=script&lang=js"
import style0 from "./restriction-modal.vue?vue&type=style&index=0&id=0fb58615&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports